import { Component } from '@angular/core';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-layout-pages',
  imports: [SidebarComponent],
  templateUrl: './layout-pages.component.html',
  styleUrl: './layout-pages.component.scss',
})
export class LayoutPagesComponent {}
